import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=c49798d4&scoped=true"
import script from "./OrderPanel.vue?vue&type=script&lang=js"
export * from "./OrderPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=c49798d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49798d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c49798d4')) {
      api.createRecord('c49798d4', component.options)
    } else {
      api.reload('c49798d4', component.options)
    }
    module.hot.accept("./OrderPanel.vue?vue&type=template&id=c49798d4&scoped=true", function () {
      api.rerender('c49798d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/OrderPanel.vue"
export default component.exports